@if (!isTotemRoute) {
  <app-header></app-header>
}

<div class="main-container" [class.totem-mode]="isTotemRoute">
  @if (!isTotemRoute) {
    <app-side-menu></app-side-menu>
  }

  <div class="content" [class.totem-content]="isTotemRoute">
    <router-outlet />

    <app-toast></app-toast>
    @if (loading) {
      <app-spinner class="spinner"></app-spinner>
    }
  </div>
</div>

@if (!isTotemRoute) {
  <app-footer></app-footer>
}
